import * as React from 'react';
import styles from './index.less';
import * as ReactDOM from 'react-dom/client';
import FFilePreviewer from './FFilePreviewer';

interface fFilePreviewerProps {
  url: string;
  mime: string;
}

type ReturnData = null;

function fFilePreviewer({ url, mime }: fFilePreviewerProps): Promise<ReturnData> {
  return new Promise<ReturnData>((resolve) => {
    const divRoot = self.document.body;
    const div = self.document.createElement('div') as HTMLDivElement;
    divRoot.appendChild(div);
    const root = ReactDOM.createRoot(div);
    return root.render(<FFilePreviewer
      url={url}
      mime={mime}
      onClose={() => {
        setTimeout(() => {
          resolve(null);
          root.unmount();
          div.remove();
        }, 1);
      }}
    />);
  });
}

export default fFilePreviewer;
